import { event } from '../content/event';

const details = [
  { label: 'Date', value: event.displayDate, icon: '12' },
  { label: 'Time', value: event.displayTime, icon: '7' },
  { label: 'Location', value: event.location, icon: '⌖' },
  { label: 'Potluck', value: event.potluck, icon: '+' },
  { label: 'On Brent', value: event.hostProvides, icon: 'B' },
  { label: 'Your people', value: event.guestPolicy, icon: '2' },
];

function EventDetails() {
  return (
    <section className="details section" id="details" aria-labelledby="details-title">
      <div className="section-heading">
        <p className="eyebrow">The particulars</p>
        <h2 id="details-title">Come hungry. Leave happy.</h2>
        <p>Good friends, great food, and one comically large bird.</p>
      </div>
      <dl className="details-grid">
        {details.map(({ label, value, icon }) => (
          <div className="detail-card" key={label}>
            <span className="detail-card__icon" aria-hidden="true">{icon}</span>
            <dt>{label}</dt><dd>{value}</dd>
          </div>
        ))}
      </dl>
      <p className="deadline-note"><strong>Kindly RSVP by {event.rsvpDeadline}.</strong> It helps us find a turkey-sized seat for everybody.</p>
    </section>
  );
}

export default EventDetails;

